export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="border-t px-6 py-16 text-center"
            style={{ borderColor: "rgba(212,175,55,0.35)", background: "var(--blush)" }}
        >
            <div
                className="mx-auto flex h-16 w-16 items-center justify-center rounded-full"
                style={{ background: "var(--wine)", border: "2px solid rgba(212,175,55,0.7)" }}
            >
                <span className="font-display text-xl" style={{ color: "var(--ivory)" }}>
                    V♡D
                </span>
            </div>
            <p className="font-display mt-5 text-2xl tracking-tight" style={{ color: "var(--wine)" }}>
                Vijju &amp; Dileep
            </p>
            <p className="font-display mt-1 text-lg italic" style={{ color: "var(--rose)" }}>
                A blessed union
            </p>
            <p className="mt-4 text-xs tracking-[0.25em] uppercase" style={{ color: "var(--muted)" }}>
                24 November 2026 · Bera Hambro Ki Bawri, Rajasthan
            </p>
            <p className="mt-8 text-[0.7rem]" style={{ color: "var(--muted)" }}>
                Crafted with love for our families
            </p>
        </footer>
    );
}
